// Services
import petWeightService from '@/app/services/main/pets/pets-service.js';

// Third party libraries
import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

export default {
	name: 'ModalAddTreatment',
	components: {
		DatePicker
	},
	mixins: [
		toastMessageMixins,
		dateMixins,
		userMixins
	],
	props: {
		
	},
	data() {
		return this.initializeModalData();
	},
	computed: {
		validationRules() {
			let fields = {
				petWeight: {}
			}

			fields = vuelidateUtil.setRequiredValidation(fields, 'petWeight');
			fields = vuelidateUtil.setMinValueValidation(fields, 'petWeight', .2);

			return fields;
		},
		weightIsChanged() {
			if (this.modalContent.action === 'Edit') {
				return parseFloat(this.modalContent.weight.weight) !== parseFloat(this.petWeight);
			} else {
				return true;
			}
		},
		buttonLabel() {
			return this.modalContent.action === 'Edit' ? 'Update weight' : 'Add Weight'
		}
	},
	watch: {
		isAddModalLoading(isLoading) {
			if (!isLoading) {
				this.closeModal();
			}
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		initializeModalData() {
			return {
				petWeight: '',
				isAddModalLoading: false,
				modalContent: {}
			}
		},
		show(modalContent) {
			this.clearModalFields();
			this.modalContent = modalContent;

			if(this.modalContent.weight && this.modalContent.weight.weight) {
				this.petWeight = this.modalContent.weight.weight;
			}

			$(this.$refs.modalAddEditPetWeight).modal('show');
		},
		closeModal() {
			$(this.$refs.modalAddEditPetWeight).modal('hide');
            this.$emit('closeAddEditPetWeight');
		},
		clearModalFields() {
			Object.assign(this.$data, this.initializeModalData());
			this.$v.$reset();
		},
		onSaveChanges() {
			const params = {
				weight: this.petWeight
			};

			const { SUCCESS_ADD_WEIGHT, ERROR_ADD_WEIGHT,  SUCCESS_EDIT_WEIGHT, ERROR_EDIT_WEIGHT } = this.toastMessages.pet(this.getActivePet.name);
			
			if (this.modalContent.action === 'Add') {
				petWeightService.addPetWeight(this.getActivePet.id, params)
					.then(res => {
						if(res.status === STATUS_CODES.SUCCESS) {
							this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_WEIGHT);
							this.getUserDetailsAPI(true, this.getActivePet.id);
							this.closeModal();
						} else {
							this.showAPIErrorToast(ERROR_ADD_WEIGHT, res);
						}
					});
			} else {
				params.petWeightId = this.modalContent.weight.id;
				petWeightService.editPetWeight(this.getActivePet.id, params)
					.then(res => {
						if(res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_EDIT_WEIGHT);
							this.getUserDetailsAPI(true, this.getActivePet.id);
							this.closeModal();
						} else {
							this.showAPIErrorToast(ERROR_EDIT_WEIGHT, res);
						}
					});
			}
		},
		formatNumberField(field) {
			const number = parseFloat(this[field]).toFixed(2);

			if (field < 0) {
				this[field] = '0.00';
			} else {
				this[field] = isNaN(number) ? parseFloat('0').toFixed(2) : number;
			}
		}
	},
	validations() {
		return this.validationRules;
	}
} 